import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'components/ui/sonner';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { LeagueProvider, LeagueContext } from './context/LeagueContext';
import CreatorLayout from './components/layout/CreatorLayout';
import Login from './components/Login';
import CreatorRankings from './components/rankings/CreatorRankings';
import Lineups from './components/studio/Lineups';
import BlogEditor from './components/studio/BlogEditor';
import BlogPostEditor from './components/studio/BlogPostEditor';
import ReferralCentre from './components/referrals/ReferralCentre';
import CommercialOffer from './components/offer/CommercialOffer';

// Protected route wrapper that requires authentication
function ProtectedRoute({ children }) {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <CreatorLayout>{children}</CreatorLayout>;
}

// Rankings page wrapper
function RankingsPage() {
  const { user } = useContext(AuthContext);
  return <CreatorRankings user={user} />;
}

// Lineups page wrapper
function LineupsPage() {
  const { user } = useContext(AuthContext);
  const { activeLeague } = useContext(LeagueContext);
  return (
    <Lineups
      user={user}
      activeLeague={activeLeague}
      setLoading={() => {}}
      setError={() => {}}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <LeagueProvider>
        <Routes>
          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* Commercial offer (landing page) */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <CommercialOffer />
              </ProtectedRoute>
            }
          />

          {/* Draft rankings */}
          <Route
            path="/rankings"
            element={
              <ProtectedRoute>
                <RankingsPage />
              </ProtectedRoute>
            }
          />

          {/* Predicted lineups */}
          <Route
            path="/lineups"
            element={
              <ProtectedRoute>
                <LineupsPage />
              </ProtectedRoute>
            }
          />

          {/* Blog */}
          <Route
            path="/blog"
            element={
              <ProtectedRoute>
                <BlogEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog/new"
            element={
              <ProtectedRoute>
                <BlogPostEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog/edit/:id"
            element={
              <ProtectedRoute>
                <BlogPostEditor />
              </ProtectedRoute>
            }
          />

          {/* Referrals */}
          <Route
            path="/referrals"
            element={
              <ProtectedRoute>
                <ReferralCentre />
              </ProtectedRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </LeagueProvider>
    </AuthProvider>
  );
}

export default App;
